@import "~@govbr-ds/core/src/components/message/message";

:host {
  display: block;

  .icon-space {
    margin-right: var(--spacing-scale-half);
  }
}
